import { IntakeLabel } from '../../entities/intake-label.interface';

export interface AishDeclarationLabelsLookup extends IntakeLabel {
  label: string;
  orderedListItem?: number;
  excludeFromPdf?: boolean;
  placeHolder?: boolean;
}

export const AishDeclarationLabels: { [name: string]: AishDeclarationLabelsLookup } = {
  agreeDeclarationContent: {
    label: `
        I declare the information I am giving about me, my spouse/partner (if applicable) and my dependent child(ren) (if applicable) is true and complete, and I understand that intentionally withholding information or giving false or incomplete information is an offence which could result in criminal charges.
    `,
  },
  agreeDeclaration: {
    label: 'I have read and agree to the Declaration above.',
    excludeFromPdf: true,
  },
};
